import { z } from 'zod'

export const ContactFormSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  message: z.string().min(10, 'Message must be at least 10 characters'),
  name: z.string().min(2, 'Name must be at least 2 characters'),
})

export type ContactFormSchemaType = z.infer<typeof ContactFormSchema>
